export const MUTE_ALL_SITE = 275;
export const TURN_ON_PUSH_FIRST_TIME = 273;
export const TOGGLE_PUSH = 276;
export const TOGGLE_NOTIFICATION_GROUP = 276;
export const BROWSER_PERMISSION_TOGGLE_DISPLAYED = 274;
export const IS_ONEAPP_INSTALLED = 277;
export const INSTALL_ONEAPP_CLICKED = 315;
export const DESKTOP_PUSH_PERMISSIONS_DENIED = 278;
export const CLICK_ON_CHANNEL_SETTINGS = 379;
export const CLICK_ON_CHANNEL_LINK = 380;
